import React from "react";
import "./about-us.css";
import Footer from "./Components/Footer/Footer";
import Navbar from "./Components/Navbar/Navbar";
import Reveal from "./Components/Reveal/Reveal";
import { images } from "./config/imagePaths";

export default function AboutUs() {
  return (
    <div className="app-container">
      <Navbar />
      <main className="main-content about-main">
        <h1>About Us</h1>

        <Reveal as="section" className="about-intro">
          <p>
            Ignite was created to bring fresh energy, creativity, and expertise
            to the Irish corporate events world. Led by Willie Hyland and Alison
            O'Kelly, we combine years of experience across corporate wellness,
            event delivery, team development, communication, and leadership.
          </p>
        </Reveal>

        <section className="about-team">
          <Reveal className="about-block about-block-alison">
            <div className="about-headshot-wrap">
              <a href="https://www.linkedin.com/in/alison-o-kelly-4a927626b/" target="_blank" rel="noopener noreferrer">
                <img
                  src={images.team.alison}
                  alt="Alison O'Kelly"
                  className="about-headshot"
                  decoding="async"
                />
              </a>
            </div>
            <div className="about-block-text">
              <h2>Alison O'Kelly</h2>
              <p>
              Alison O'Kelly is the founder of AOK Mentoring, where she
              specialises in public speaking training, professional development,
              and marketing consultancy. Her background in communication, brand
              strategy, and people development brings a powerful, human-focused
              dimension to Ignite's approach.
            </p>
            </div>
          </Reveal>

          <Reveal className="about-block about-block-willie">
            <div className="about-headshot-wrap">
              <a href="https://www.linkedin.com/in/willie-hyland-1761192b/" target="_blank" rel="noopener noreferrer">
                <img
                  src={images.team.willie}
                  alt="Willie Hyland"
                  className="about-headshot"
                  decoding="async"
                />
              </a>
            </div>
            <div className="about-block-text">
              <h2>Willie Hyland</h2>
              <p>
              Willie continues in his role as Director of Midland Escape, one of
              Ireland's leading corporate wellness activity providers. Through
              Ignite, he brings that same passion, reliability, and hands-on
              experience to a new space, crafting memorable conferences, gala
              dinners, corporate celebrations, and bespoke events.
            </p>
            </div>
          </Reveal>
        </section>

        <Reveal as="section" className="about-close">
          <p>
            Together, Ignite blends creative event design, professional
            delivery, and genuine people expertise. We're here to create
            experiences that spark connection, energise teams, and bring
            corporate events to life.
          </p>
        </Reveal>
      </main>
      <Footer />
    </div>
  );
}
